import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";

import { UnauthorizedUserComponent } from "./unauthorized-user/unauthorized-user.component";
import { ComplianceRegulationsComponent } from "./compliance-regulations/compliance-regulations.component";
import { MsalGuard } from "@azure/msal-angular";
import { MsalAuthGaurd } from "./sign-in/activate-guad";
import { QrBrandingComponent } from "./qr-branding/qr-branding.component";

const routes: Routes = [
  {
    path: "home",
    pathMatch: "full",
    component: HomeComponent,
    canActivate: [MsalAuthGaurd],
  },
  {
    path: "metrics",
    loadChildren: () =>
      import("./metrics/metrics.module").then((m) => m.MetricsModule),
    canActivate: [MsalAuthGaurd],
  },
  {
    path: "solarForms",
    loadChildren: () =>
      import("./solar-forms/solarForms.module").then(
        (m) => m.SolarFormsModule
      )
  },
  {
    path: "admin",
    loadChildren: () =>
      import("./admin/admin.module").then((m) => m.AdminModule),
    canActivate: [MsalAuthGaurd],
  },  
  {
    path: "complianceRegulations",
    pathMatch: "full",
    component: ComplianceRegulationsComponent,
    canActivate: [MsalAuthGaurd],
  },
  {
    path: "branding-qr-code-generator",
    pathMatch: "full",
    component: QrBrandingComponent,
    canActivate: [MsalAuthGaurd],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
